import React from 'react';

/**
 * Small red "NEW" pill badge shown on freshly added catalog items.
 * Auto-hides after `newUntil` date passes.
 *
 * Usage:
 *   {isNew(texture.newUntil) && <NewBadge className="absolute top-2 right-2" />}
 */

export const isNew = (newUntil) => {
  if (!newUntil) return false;
  const d = Date.parse(newUntil);
  if (Number.isNaN(d)) return false;
  return Date.now() < d;
};

export const NewBadge = ({ className = '', size = 'md' }) => {
  const sizes = {
    sm: 'px-1.5 py-0.5 text-[8px] tracking-wider',
    md: 'px-2 py-0.5 text-[10px] tracking-wider',
    lg: 'px-2.5 py-1 text-xs tracking-widest',
  };
  return (
    <span
      data-testid="new-badge"
      className={`inline-block text-white rounded-md select-none pointer-events-none brand-name ${sizes[size] || sizes.md} ${className}`}
      style={{
        backgroundColor: '#8b4444',
        fontWeight: 800,
      }}
    >
      NEW
    </span>
  );
};

export default NewBadge;
